import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { BREADCRUMB_SEPARATOR } from '../../config/constants';

const BreadcrumbComponent = (props) => {
    const location = useLocation();
    let { breadcrumb_items } = props

    return (
        <Breadcrumb separator={BREADCRUMB_SEPARATOR}>
            {breadcrumb_items?.map((item, idx) => (
                <Breadcrumb.Item key={idx}>
                    {item.to ?
                        <Link to={item.to} onClick={item.onClick ?? null} state={{...location.state}} > {item.label} </Link>
                        :
                        item.label
                    }
                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}

export default BreadcrumbComponent;
